import { useCallback, useState } from "react";
import { LayoutChangeEvent } from "react-native";

// Small enough to fit the caret when the field is empty, without forcing an
// initial layout jump once the measured text reports its real width.
export const MIN_INPUT_WIDTH = 12;

/**
 * Tracks the width an auto-width numeric input field should render at, so
 * the affix (currency symbol, "%", etc.) hugs the digits instead of sitting
 * at a fixed offset. Feed the returned `onMeasure` to the hidden measured
 * `Text` that mirrors the displayed value (see `MeasuredHiddenText`).
 */
export function useAutoWidth(minWidth: number = MIN_INPUT_WIDTH) {
  const [width, setWidth] = useState(minWidth);

  const onMeasure = useCallback(
    (event: LayoutChangeEvent) => {
      setWidth(Math.max(minWidth, event.nativeEvent.layout.width));
    },
    [minWidth],
  );

  return { width, onMeasure };
}
